<p-toast />
<router-outlet />
<img class="novatellus-logo" [src]="novatellusLogo()" alt="" aria-hidden="true" />
